import { useId, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Dialog, Textarea } from '@artosera/ui';
import { useShellContext } from '../shell/context.js';
import { galerieALaction } from '../../auth/sujet.js';
import { deposantApi, useAccesDeposant, useGesteDeposant } from '../../api/espaceDeposant.js';
import { Field } from '../Field.js';
import styles from './DepotsRecus.module.css';
export function AccesDeposant({
  contactId,
  emails,
}: {
  contactId: string;
  emails: readonly string[];
}) {
  const { galerie, galerieSlug } = useShellContext(),
    { t } = useTranslation(['regie', 'commun']),
    prefixe = useId();
  const lecture = useAccesDeposant(galerieSlug, contactId),
    [geste, setGeste] = useState<string | null>(null),
    [motif, setMotif] = useState('');
  const mutation = useGesteDeposant(galerieSlug, (v: { geste: string; motif: string }, appel) => {
    const acces = lecture.data?.acces;
    if (!acces) return deposantApi.inviter(galerieSlug, contactId, appel);
    const corps = {
      version: acces.version,
      ...(['suspendre', 'revoquer'].includes(v.geste) ? { motif: v.motif } : {}),
    };
    return deposantApi.accesGeste(galerieSlug, acces.id, v.geste, corps, appel);
  });
  const acces = lecture.data?.acces;
  if (lecture.isPending) return <p role="status">{t('commun:chargement')}</p>;
  if (lecture.isError) return <p role="alert">{t('commun:erreurReseau')}</p>;
  const actions: string[] = [];
  if (!acces) actions.push('inviter');
  if (acces?.etat === 'invite' || acces?.etat === 'actif')
    actions.push('renvoyer', 'suspendre', 'revoquer');
  if (acces?.etat === 'suspendu') actions.push('reactiver', 'revoquer');
  return (
    <section className={styles.page}>
      <h3>{t('deposant.espace')}</h3>
      {acces && (
        <p>
          {acces.email} · {t(`espaceCollectionneur.etats.${acces.etat}`)}
        </p>
      )}
      {lecture.data?.ecartEmail && <p role="status">{t('espaceCollectionneur.ecartEmail')}</p>}
      {galerieALaction(galerie, 'contacts:write') && (
        <div className={styles.actions}>
          {actions.map((a) => (
            <Button
              key={a}
              variant="secondary"
              disabled={a === 'inviter' && !emails.length}
              onClick={() => {
                setMotif('');
                mutation.reset();
                setGeste(a);
              }}
            >
              {t(`deposant.${a}`)}
            </Button>
          ))}
        </div>
      )}
      {geste && (
        <Dialog
          open
          title={t(`deposant.${geste}`)}
          closeLabel={t('commun:actions.fermer')}
          onOpenChange={(o) => {
            if (!o) setGeste(null);
          }}
        >
          <form
            className={styles.formulaire}
            onSubmit={(e) => {
              e.preventDefault();
              mutation.mutate({ geste, motif }, { onSuccess: () => setGeste(null) });
            }}
          >
            {['suspendre', 'revoquer'].includes(geste) && (
              <Field htmlFor={`${prefixe}-motif`} label={t('deposant.motif')}>
                <Textarea
                  id={`${prefixe}-motif`}
                  required
                  maxLength={1000}
                  value={motif}
                  onChange={(e) => setMotif(e.target.value)}
                />
              </Field>
            )}
            <Button type="submit" loading={mutation.isPending} disabled={mutation.isError}>
              {t('commun:actions.confirmer')}
            </Button>
            {mutation.isError && <p role="alert">{t('deposant.erreur')}</p>}
          </form>
        </Dialog>
      )}
    </section>
  );
}
